/* eslint-disable @typescript-eslint/no-var-requires */
export const cobrandDatalayer = require('./cobrandDatalayer.graphql');
// export const contactInformationRemembered = require('./contactInformationRemembered.graphql');
// export const rewardsSummary = require('./rewardsSummary.graphql');
// export const promotions = require('./promotions.graphql');
// export const searchOrdersByRewardsNumber = require('./searchOrdersByRewardsNumber.graphql');
export const propertiesById = require('./propertiesById.graphql');
export const phoenixFetchOrderDetails = require('./phoenixFetchOrderDetails.graphql');
export const phoenixBookCartSOC = require('./phoenixBookCartSoc.graphql');
// export const basicInformation = require('./basicInformation.graphql');
// export const contactInformationNoTrips = require('./contactInformationNoTrips.graphql');
// export const contactInformationWithTrips = require('./contactInformationWithTrips.graphql');
export const phoenixReservationConfirmation = require('./phoenixReservationConfirmation.graphql');
